import React from 'react';
import ProductPage from '../product_page/productPage';

const Men = () => {
    return <ProductPage
        page_title={'Men'}
        initial_filters={{gender: 'MEN'}}
        seo={{
            title: "Men's Fashion from Emerging Brands | The Sidewalk",
            description: "from emerging brands. Discover hoodies, jackets, jeans, and more."
        }}
    />;
};

export default Men;